import api from './api';

const TIMEOUT = 60000;

export const notesApi = {
  list: (params) =>
    api.get('/notes', { params, timeout: TIMEOUT }).then((r) => r.data),

  counts: (params) =>
    api.get('/notes/counts', { params }).then((r) => r.data),

  create: (body) =>
    api.post('/notes', body, { timeout: TIMEOUT }).then((r) => r.data),

  update: (id, body, params) =>
    api.patch(`/notes/${id}`, body, { params, timeout: TIMEOUT }).then((r) => r.data),

  remove: (id, params) =>
    api.delete(`/notes/${id}`, { params }).then((r) => r.data),

  setStatus: (id, status, params) =>
    api.post(`/notes/${id}/status`, { status }, { params }).then((r) => r.data),

  patchTask: (id, body, params) =>
    api.patch(`/notes/${id}/task`, body, { params }).then((r) => r.data),

  patchImportant: (id, isImportant, params) =>
    api.patch(`/notes/${id}/important`, { is_important: !!isImportant }, { params }).then((r) => r.data),

  markViewed: (id, params) =>
    api.post(`/notes/${id}/view`, null, { params }).then((r) => r.data),

  searchUsers: (params) =>
    api.get('/notes/users/search', { params }).then((r) => r.data),

  signAttachment: (body, page_key) =>
    api.post('/notes/attachments/sign', body, { params: { page_key } }).then((r) => r.data),
};

/**
 * Upload a file via a presigned PUT URL straight to S3.
 * Returns the {key, name, size, content_type} record we'll persist on the note.
 */
export const uploadAttachment = async ({ accountId, pageKey, file }) => {
  const sign = await notesApi.signAttachment(
    {
      account_id: accountId,
      filename: file.name,
      content_type: file.type || 'application/octet-stream',
      size: file.size,
    },
    pageKey,
  );
  const resp = await fetch(sign.upload_url, {
    method: sign.method || 'PUT',
    headers: sign.headers || { 'Content-Type': file.type || 'application/octet-stream' },
    body: file,
  });
  if (!resp.ok) {
    throw new Error(`Upload failed: ${resp.status}`);
  }
  return {
    key: sign.key,
    name: file.name,
    size: file.size,
    content_type: sign.content_type,
  };
};
